
import { mapGetters } from 'vuex'
export default {
    props: {
        value: {
            type: String,
            default: 'phone'
        },
        allowedMethods: {
            type: Array,
            default: () => []
        },
        aep: {
            type: Boolean,
            default: false
        },
        asFullserve: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['isAEP', 'getScheduleHelpText', 'isBetweenSep1Oct12']),
        hasMultiple () {
            return this.allowedMethods.length > 1
        }
    },
    watch: {
        allowedMethods (newValue) {
            if (this.value && !newValue.includes(this.value)) {
                this.$emit('input', newValue[0] || null)
            }
            if (!newValue?.length) {
                this.$emit('input', null)
            }
        }
    },
    mounted () {
        this.setGlobal('$method', this)
    },
    methods: {
        hasMethod (method) {
            return this.allowedMethods.includes(method)
        },
    }
}
